import {
  GET_AI_MODELS_REQUEST,
  GET_AI_MODELS_SUCCESS,
  GET_AI_MODELS_ERROR,
  UPDATE_AI_MODEL_REQUEST,
  UPDATE_AI_MODEL_SUCCESS,
  UPDATE_AI_MODEL_ERROR,
  TEST_AI_MODEL_CONNECTION_REQUEST,
  TEST_AI_MODEL_CONNECTION_SUCCESS,
  TEST_AI_MODEL_CONNECTION_ERROR,
  CLEAR_AI_MODEL_TEST_RESULT,
  RESET_AI_MODELS_STATE,
  MLHUB_HEALTH_CHECK_REQUEST,
  MLHUB_HEALTH_CHECK_SUCCESS,
  MLHUB_HEALTH_CHECK_ERROR,
} from "../types";

const initialState = {
  models: [],
  loading: false,
  error: null,
  updating: false,
  testingConnection: {},  // { modelType: boolean }
  connectionTestResults: {},  // { modelType: { success, message, response_time_ms, status_code, model_version, timestamp } }
  mlhubHealth: {
    checking: false,
    healthy: null,
    error: null,
    lastChecked: null,
  },
};

export default function aiModelsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_AI_MODELS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_AI_MODELS_SUCCESS:
      return {
        ...state,
        loading: false,
        models: payload || [],
        error: null,
        // Reset test results when loading fresh data
        connectionTestResults: {},
      };
    case GET_AI_MODELS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case UPDATE_AI_MODEL_REQUEST:
      return {
        ...state,
        updating: true,
        error: null,
      };
    case UPDATE_AI_MODEL_SUCCESS:
      return {
        ...state,
        updating: false,
        models: state.models.map((model) =>
          model.model_type === payload.model_type ? { ...model, ...payload } : model
        ),
        error: null,
      };
    case UPDATE_AI_MODEL_ERROR:
      return {
        ...state,
        updating: false,
        error: payload,
      };

    case TEST_AI_MODEL_CONNECTION_REQUEST:
      return {
        ...state,
        testingConnection: {
          ...state.testingConnection,
          [payload.modelType]: true,
        },
        connectionTestResults: {
          ...state.connectionTestResults,
          [payload.modelType]: null,
        },
        error: null,
      };
    case TEST_AI_MODEL_CONNECTION_SUCCESS:
      return {
        ...state,
        testingConnection: {
          ...state.testingConnection,
          [payload.modelType]: false,
        },
        connectionTestResults: {
          ...state.connectionTestResults,
          [payload.modelType]: {
            success: true,
            ...payload.result,
          },
        },
        error: null,
      };
    case TEST_AI_MODEL_CONNECTION_ERROR:
      return {
        ...state,
        testingConnection: {
          ...state.testingConnection,
          [payload.modelType]: false,
        },
        connectionTestResults: {
          ...state.connectionTestResults,
          [payload.modelType]: {
            success: false,
            message: payload.error,
          },
        },
        error: payload.error,
      };

    case CLEAR_AI_MODEL_TEST_RESULT: {
      // No-op when nothing to clear. The AiModelConfigModal dispatches this
      // on mount + unmount; without the early return Redux returns a new
      // reference, useSelector re-renders the modal in the same tick its
      // Syncfusion DialogComponent is still finishing its first dataBind,
      // and Syncfusion crashes in componentDidUpdate → onPropertyChanged
      // with "Cannot read properties of undefined (reading 'destroy')".
      const current = state.connectionTestResults
        ? state.connectionTestResults[payload.modelType]
        : undefined;
      if (current == null) return state;
      return {
        ...state,
        connectionTestResults: {
          ...state.connectionTestResults,
          [payload.modelType]: null,
        },
      };
    }

    case RESET_AI_MODELS_STATE:
      return {
        ...initialState,
        // Keep models data but reset transient state
        models: state.models,
      };

    case MLHUB_HEALTH_CHECK_REQUEST:
      return {
        ...state,
        mlhubHealth: {
          ...state.mlhubHealth,
          checking: true,
          error: null,
        },
      };

    case MLHUB_HEALTH_CHECK_SUCCESS:
      return {
        ...state,
        mlhubHealth: {
          checking: false,
          healthy: payload.healthy,
          error: null,
          lastChecked: payload.timestamp,
        },
      };

    case MLHUB_HEALTH_CHECK_ERROR:
      return {
        ...state,
        mlhubHealth: {
          checking: false,
          healthy: false,
          error: payload,
          lastChecked: new Date().toISOString(),
        },
      };

    default:
      return state;
  }
}
